<ul *ngIf="isOpen && predictions.length > 0" class="predictions">
  <li
    *ngFor="let p of predictions; let i = index"
    class="prediction"
    [class.highlighted]="i === highlightedIndex"
    (mousedown)="selectPrediction(p); $event.preventDefault()"
  >
    <span class="main">{{ p.mainText?.text }}</span>
    <span class="secondary">{{ p.secondaryText?.text }}</span>
  </li>
</ul>
